import { TopBarProps } from '~/components/TopBar/models';
import { DelayedDeliveryBar } from '~/mappers/delayedDeliveryBar/models';

export const delayedDeliveryBarMapper = ({
  messageDisplayed,
  delayedDeliveryMessage,
  isShoppingCartPage,
}: DelayedDeliveryBar): TopBarProps => ({
  messages: [
    {
      text: delayedDeliveryMessage,
    },
  ],
  className: 'delayed-delivery',
  soloMode: true,
  showInfoBar:
    isShoppingCartPage && messageDisplayed && delayedDeliveryMessage.length > 0,
});
